module.exports = __webpack_public_path__ + "img/04-11.ddabb37b.png";